import { render, staticRenderFns } from "./CertQuery.vue?vue&type=template&id=67134608&scoped=true"
import script from "./CertQuery.vue?vue&type=script&lang=js"
export * from "./CertQuery.vue?vue&type=script&lang=js"
import style0 from "./CertQuery.vue?vue&type=style&index=0&id=67134608&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67134608",
  null
  
)

export default component.exports